import { ApiResponse, Proforma } from '../models';
import apiClient from './api/apiClient';
import { handleApiError } from './api/apiErrorHandler';

export interface GetOrdersResponse extends ApiResponse {
    results: {
        proformas: Proforma[];
    };
    customerId?: number;
}

class OrderService {
    async getOrders(customerId: number): Promise<GetOrdersResponse> {
        return await apiClient
            .get(`/customers/${customerId}/proformas`)
            .then(
                (response) => ({ ...response.data, customerId }),
                (error) => handleApiError(error, 'Failed to retrieve orders.')
            );
    }
}

export const orderService = new OrderService();
